import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIDialogActions(theme: Theme): Components['MuiDialogActions'] {
  return {
    styleOverrides: {
      root: {
        padding: theme.spacing(0, 4, 4, 4),
        '& > :not(:first-of-type)': {
          marginLeft: theme.spacing(2),
        },
      },
    },
  };
}
